import { render, staticRenderFns } from "./PaddleStatus.vue?vue&type=template&id=a5d4ae52&"
import script from "./PaddleStatus.vue?vue&type=script&lang=js&"
export * from "./PaddleStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports